export const LOGOS = {
  BRAND: {
    LIGHT: {
      icon: "/images/logos/antos/icon.png",
      small: "/images/logos/Plus100.png",
      medium: "/images/logos/Plus100.png",
      large: "/images/logos/Plus100.png",
    },
    DARK: {
      icon: "/images/logos/antos/icon.png",
      small: "/images/logos/Plus100.png",
      medium: "/images/logos/Plus100.png",
      large: "/images/logos/Plus100.png",
    },
  },
  BROKER1: {
    LIGHT: {
      icon: "/images/logos/antos/icon.png",
      small: "/images/logos/antos/icon.png",
      medium: "/images/logos/antos/icon.png",
      large: "/images/logos/antos/icon.png",
    },
    DARK: {
      icon: "/images/logos/antos/icon.png",
      small: "/images/logos/Plus100.png",
      medium: "/images/logos/Plus100.png",
      large: "/images/logos/Plus100.png",
    },
  },
  BROKER2: {
    LIGHT: {
      icon: "",
      small: "",
      medium: "",
      large: "",
    },
    DARK: {
      icon: "",
      small: "",
      medium: "",
      large: "",
    },
  },
};

export const CURRENT_BROKER = "NEXTRADES";
export const CURRENT_BROKER_NAME = "nextrades";
export const CURRENT_BROKER_ID = "8";
export const CURRENT_SERVER_NAME = "AntosPinnacles-Trade";
export const CURRENT_DEFAULT_SYMBOL = "XAUUSD";
export const enableVideoTutorial = false;
export const BUILD_CANVAS_STRATEGY = "d527b554-530f-4d7a-9a61-af1b53a58bb5";
export const CURRENT_SERVER_URL = "nextrades.trylevel2.com";
export const isMT5 = true;
export const isBrokerBranch = true;

export const BROKER_LOGO = {
  ANTOS: {
    LIGHT: {
      icon: "/images/logos/antos/icon.png",
      small: "/images/logos/antos/icon.png",
      medium: "/images/logos/antos/icon.png",
      large: "/images/logos/antos/icon.png",
      favicon: "/favicons/antos/favicon.ico",
      textLogo: "/images/logos/antos/Lightspeed.png",
    },
    DARK: {
      icon: "/images/logos/antos/icon.png",
      small: "/images/logos/antos/icon.png",
      medium: "/images/logos/antos/icon.png",
      large: "/images/logos/antos/icon.png",
      favicon: "/favicons/antos/favicon.ico",
      textLogo: "/images/logos/antos/Lightspeed.png",
    },
  },
  SPARK: {
    LIGHT: {
      icon: "/images/logos/spark/apple-touch-icon.png",
      small: "/images/logos/spark/apple-touch-icon.png",
      medium: "/images/logos/spark/apple-touch-icon.png",
      large: "/images/logos/spark/Sparkmarkets_favicon-16x16.png",
      favicon: "/images/logos/spark/Sparkmarkets_favicon-16x16.png.png",
      textLogo: "/images/logos/spark/spark_text.svg",
    },
    DARK: {
      icon: "/images/logos/spark/apple-touch-icon.png",
      small: "/images/logos/spark/apple-touch-icon.png",
      medium: "/images/logos/spark/apple-touch-icon.png",
      large: "/images/logos/spark/Sparkmarkets_favicon-16x16.png",
      favicon: "/images/logos/spark/Sparkmarkets_favicon-16x16.png.png",
      textLogo: "/images/logos/spark/spark_text.svg",
    },
  },
  Lightspeed: {
    LIGHT: {
      icon: "/images/logos/Lightspeed/Lightspeed_logo.png",
      small: "/images/logos/Lightspeed/Lightspeed_logo.png",
      medium: "/images/logos/Lightspeed/Lightspeed_logo.png",
      large: "/images/logos/Lightspeed/Lightspeed_logo.png",
      favicon: "/images/logos/Lightspeed/Lightspeed_logo.png",
      textLogo: "/images/logos/Lightspeed/Lightspeed_logo_text.png",
    },
    DARK: {
      icon: "/images/logos/Lightspeed/Lightspeed_logo.png",
      small: "/images/logos/Lightspeed/Lightspeed_logo.png",
      medium: "/images/logos/Lightspeed/Lightspeed_logo.png",
      large: "/images/logos/Lightspeed/Lightspeed_logo.png",
      favicon: "/images/logos/Lightspeed/Lightspeed_logo.png",
      textLogo: "/images/logos/Lightspeed/Lightspeed_logo_text.png",
    },
  },
  LIGHTSPEED: {
    LIGHT: {
      icon: "/images/logos/lightspeed/logo-dark.svg",
      small: "/images/logos/lightspeed/logo-dark.svg",
      medium: "/images/logos/lightspeed/logo-dark.svg",
      large: "/images/logos/lightspeed/logo-dark.svg",
      favicon: "/images/logos/lightspeed/logo-dark.svg",
      textLogo: "/images/logos/lightspeed/logo-dark.svg",
    },

    DARK: {
      icon: "/images/logos/lightspeed/logo-light.svg",
      small: "/images/logos/lightspeed/logo-light.svg",
      medium: "/images/logos/lightspeed/logo-light.svg",
      large: "/images/logos/lightspeed/logo-light.svg",
      favicon: "/images/logos/lightspeed/logo-light.svg",
      textLogo: "/images/logos/lightspeed/logo-light.svg",
    },
  },
  MATCHTRADE: {
    LIGHT: {
      icon: "/images/logos/matchtrade/icon.png",
      small: "/images/logos/matchtrade/icon.png",
      medium: "/images/logos/matchtrade/icon.png",
      large: "/images/logos/matchtrade/icon.png",
      favicon: "/images/logos/matchtrade/icon.png",
      textLogo: "/images/logos/matchtrade/text-logo.svg",
    },

    DARK: {
      icon: "/images/logos/matchtrade/icon.png",
      small: "/images/logos/matchtrade/icon.png",
      medium: "/images/logos/matchtrade/icon.png",
      large: "/images/logos/matchtrade/icon.png",
      favicon: "/images/logos/matchtrade/icon.png",
      textLogo: "/images/logos/matchtrade/text-logo.svg",
    },
  },
  CTRADER: {
    LIGHT: {
      icon: "/images/logos/ctrader/icon.svg",
      small: "/images/logos/ctrader/icon.svg",
      medium: "/images/logos/ctrader/icon.svg",
      large: "/images/logos/ctrader/icon.svg",
      favicon: "/images/logos/ctrader/icon.svg",
      textLogo: "/images/logos/ctrader/icon.svg",
    },

    DARK: {
      icon: "/images/logos/ctrader/icon.svg",
      small: "/images/logos/ctrader/icon.svg",
      medium: "/images/logos/ctrader/icon.svg",
      large: "/images/logos/ctrader/icon.svg",
      favicon: "/images/logos/ctrader/icon.svg",
      textLogo: "/images/logos/ctrader/icon.svg",
    },
  },
  MT5: {
    LIGHT: {
      icon: "/images/logos/mt-5/mtg-white.png",
    },

    DARK: {
      icon: "/images/logos/mt-5/mtg-white.png",
    },
  },
  FUNDORA: {
    LIGHT: {
      icon: "/images/logos/fundora/logo.svg",
    },

    DARK: {
      icon: "/images/logos/fundora/logo.svg",
    },
  },
  TRADEZERO: {
    LIGHT: {
      icon: "/images/logos/trade-zero/logo.png",
    },

    DARK: {
      icon: "/images/logos/trade-zero/logo.png",
    },
  },
  NEXTRADES: {
    LIGHT: {
      icon: "/images/logos/nextrades/logo_dark.png",
      small: "/images/logos/nextrades/logo_dark.png",
      medium: "/images/logos/nextrades/logo_dark.png",
      large: "/images/logos/nextrades/logo_dark.png",
      favicon: "/images/logos/nextrades/logo_dark.png",
      textLogo: "/images/logos/nextrades/logo_dark.png",
    },
    DARK: {
      icon: "/images/logos/nextrades/logo.png",
      small: "/images/logos/nextrades/logo.png",
      medium: "/images/logos/nextrades/logo.png",
      large: "/images/logos/nextrades/logo.png",
      favicon: "/images/logos/nextrades/logo.png",
      textLogo: "/images/logos/nextrades/logo.png",
    },
  },
};
